<template>
  <div id="comp-bottom-tab">
    <div class="tab-wrapper">
      <div
        class="tab-container"
        v-bind:class="{ active: tabActive == 'home' }"
        @click="goPage('/mc6')"
      >
        <i class="fas fa-home"></i><span>{{ $t('tabMenu.home') }}</span>
      </div>
      <div class="tab-container" @click="checkCntBeforeGo('/report')">
        <i class="fas fa-file-alt"></i><span>{{ $t('tabMenu.report') }}</span>
      </div>
      <div class="tab-container" @click="checkCntBeforeGo('/match/qr')">
        <i class="fas fa-user-friends"></i><span>{{ $t('tabMenu.friend') }}</span>
      </div>
      <div
        class="tab-container"
        v-bind:class="{ active: tabActive == 'match' }"
        @click="goPage('/match/list')"
      >
        <i class="fas fa-list-ul"></i><span>{{ $t('tabMenu.matching') }}</span>
      </div>
    </div>
    <comp-add v-if="showModal" @close="showModal = false"></comp-add>
    <comp-modal
      v-if="goTestModal"
      @cancel="goTestModal = !goTestModal"
      @confirm="goTest"
      buttonTwo
      titleShow
    >
      <h3 slot="header">{{ $t('myMenu.modalHeader') }}</h3>
      <p slot="body" v-html="$t('myMenu.modalBody')"></p>
    </comp-modal>
  </div>
</template>

<script>
import common from '@/utils/common';
import CompAdd from '@/components/CompAdd';
import CompModal from '@/components/CompModal';
import RESPONSE from '@/constants/response';
import TEST from '@/constants/test';

export default {
  name: 'comp-bottom-tab',
  mixins: [
    common,
  ],
  props: {
    tabActive: String,
  },
  data() {
    return {
      showModal: false,
      goTestModal: false,
    };
  },
  components: {
    CompAdd,
    CompModal,
  },
  methods: {
    checkCntBeforeGo(path) {
      let qCnt = this.$store.getters.getQCnt;
      if (qCnt || qCnt === 0) {
        this.checkCnt(qCnt, path);
      } else {
        this.$store.dispatch('getQuestion').then((result) => {
          if (result && result.data) {
            qCnt = result.data.data.qanum;
          } else if (result.error.resultCode === RESPONSE.NO_QUESTION.CODE) {
            qCnt = TEST.MAXIMUM;
          }

          this.$store.dispatch('setQCnt', { qCnt }).then(() => {
            this.checkCnt(qCnt, path);
          });
        });
      }
    },
    checkCnt(qCnt, path) {
      if (qCnt < TEST.MAXIMUM) {
        this.goTestModal = true;
      } else {
        this.goPage(path);
      }
    },
    goTest() {
      this.goTestModal = false;
      this.goPage('/test/question');
    },
  },
};
</script>

<style lang="scss" src="../scss/comp-bottom-tab.scss" scoped></style>




// WEBPACK FOOTER //
// src/components/CompBottomTab.vue